export default "__VITE_ASSET__Ck9VCtq4__"